export default __webpack_public_path__ + "static/media/ep-info-filled.36bfda33.svg";